import customFormItem from './components/form-item.vue';

export default customFormItem;
